import { useState, useContext, useRef } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropType from 'prop-types';
import { getSanitizedHtml } from '../util/getSanitizedHtml';
import Tooltip from './Tooltip';
import { planListIconType } from '../util/constants';
import PlanListInlineIcon from './PlanListInlineIcon';

PlanListColumn.propTypes = {
    columnId: PropType.string,
    index: PropType.number,
    value: PropType.string,
    plan: PropType.object,
    onOptionsClick: PropType.func,
    formularyDrillDownEnabled: PropType.bool,
    specialtyPharmacyDrillDownEnabled: PropType.bool,
    restrictionDrillDownEnabled: PropType.bool,
    canSelectFormulary: PropType.bool,
    canSelectRestrictions: PropType.bool,
    canSelectSpecialtyPharmacy: PropType.bool,
    includeRestrictions: PropType.bool,
    includeSpecialty: PropType.bool,
    includeFormularies: PropType.bool,
    setIncludeRestrictions: PropType.func,
    setIncludeFormularies: PropType.func,
    setIncludeSpecialty: PropType.func,
    enableInlineIcons: PropType.bool,
}

function PlanListColumn({ 
    columnId, 
    index, 
    value,
    plan,
    onOptionsClick,
    formularyDrillDownEnabled,
    restrictionDrillDownEnabled,
    specialtyPharmacyDrillDownEnabled,
    canSelectFormulary,
    canSelectRestrictions,
    canSelectSpecialtyPharmacy,
    includeRestrictions,
    includeSpecialty,
    includeFormularies,
    setIncludeRestrictions,
    setIncludeFormularies,
    setIncludeSpecialty,
    enableInlineIcons
}) {
    const [appState] = useContext(AppContext);
    const tooltipTarget = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);
	const hasIcon = value.indexOf('fa ') > -1 || value.indexOf('fal ') > -1;
    const toolTipMessage = value.indexOf('fa-user-doctor') > 0 
    ? getConfigValue(appState.config?.PlanList?.HCP.Tooltip, appState)?.Value 
    : getConfigValue(appState.config?.PlanList?.Geographic.Tooltip, appState)?.Value;
    
    const { formularyDrillDown, specialtyPharmacies, formularyRestriction, isPrintable } = plan?.data || {};
    const showIcons = enableInlineIcons && value.indexOf('data-plan-options') > -1 && isPrintable;

    function handleIncludeFormulariesClick(include) {
        //only set the state if the onOptionsClick function returns true
        if (onOptionsClick({ ...plan.data, includeFormularies: include, includeRestrictions: includeRestrictions, includeSpecialtyPharmacy: includeSpecialty })) {
            setIncludeFormularies(include);
        }
    }

    function handleIncludeSpecialtyClick(include) {
        //only set the state if the onOptionClick returns true
        if (onOptionsClick({ ...plan.data, includeSpecialtyPharmacy: include, includeFormularies: includeFormularies, includeRestrictions: includeRestrictions })) {
            setIncludeSpecialty(include);
        }
    }

    function handleIncludeRestrictionsClick(include) {
        //only set the state if the onOptionsClick function returns true
        if (onOptionsClick({ ...plan.data, includeRestrictions: include, includeFormularies: includeFormularies, includeSpecialtyPharmacy: includeSpecialty })) {
            setIncludeRestrictions(include);
        }
    }

    return (
        <div key={columnId} className={`mb-3 my-lg-0 ${showIcons ? 'pd-plan-table-cell-complex' : ''}`}>
            <div 
                ref={tooltipTarget}
                onMouseOver={() => setShowTooltip(true)}
                onFocus={() => setShowTooltip(true)}
                onMouseOut={() => setShowTooltip(false)}
                onBlur={() => setShowTooltip(false)}
                className='pd-plan-table-value' 
                dangerouslySetInnerHTML={getSanitizedHtml(value)}>
            </div>
            {showIcons && (
                <div className='pd-plan-table-options'>
                    <PlanListInlineIcon
                        showIcon={formularyDrillDownEnabled && formularyDrillDown && formularyDrillDown.length > 0}
                        iconType={planListIconType.Formulary}
                        isSelected={includeFormularies}
                        onClick={() => handleIncludeFormulariesClick(!includeFormularies)}
                        index={index}
                        enabled={canSelectFormulary}
                    />
                    <PlanListInlineIcon
                        showIcon={restrictionDrillDownEnabled && formularyRestriction && formularyRestriction.length > 0}
                        iconType={planListIconType.RestrictionNotes}
                        isSelected={includeRestrictions}
                        onClick={() => handleIncludeRestrictionsClick(!includeRestrictions)}
                        index={index}
                        enabled={canSelectRestrictions}
                    />
                    <PlanListInlineIcon
                        showIcon={specialtyPharmacyDrillDownEnabled && specialtyPharmacies && specialtyPharmacies.length > 0}
                        iconType={planListIconType.SpecialtyPharmacy}
                        isSelected={includeSpecialty}
                        onClick={() => handleIncludeSpecialtyClick(!includeSpecialty)}
                        index={index}
                        enabled={canSelectSpecialtyPharmacy}
                    />                             
                </div>
            )}
            {hasIcon &&
            <Tooltip
                text={toolTipMessage}
                placement='left'
                ref={tooltipTarget}
                showTooltip={showTooltip}
                index={index}/>}
        </div>
    )
}

export default PlanListColumn;